/* eslint-disable */
require('./AllMaterialInvalid')
require('./AllMaterialValid')
require('./indent-split-sucess')
require('./InvoicesonHold')
require('./InvoicesPaid')
require('./no_consignee')
require('./No-Actions-Available')
require('./NoArrived-AssignedIndents')
require('./NoBU-CC-TransporterFound')
require('./NoCancelled-RejectedIndents')
require('./NoDashboardAnalytics')
require('./NoDepot')
require('./NoDocumentsUploaded')
require('./NoInboundIndents')
require('./NoIndentedIndents')
require('./NoIndentsAvailable')
require('./NoIndentsDelivered-Dispatched')
require('./NoIndentsDue-NoAcceptedIndents')
require('./NoInvoicesApproved')
require('./NoInvoicesAvailable-Generated-Checked')
require('./NoInvoicesReturned')
require('./NoLoadingStarted-Ended')
require('./NoLR-EwaybillAvailable')
require('./NoMaterial-UploadMaterial')
require('./NoMaterials')
require('./NoOutboundIndents')
require('./NoRateMatrix-Detention')
require('./NoResultsForAppliedFilters')
require('./NoRoles-Consignees')
require('./NoSearchResults-NoRecordsFound')
require('./noshipper')
require('./NoVouchersAvailable-Generated-Checked')
require('./PartialMaterialValid')
require('./SpareState-1')
require('./SpareState-2')
require('./Tracking')
